/**
 * This patch migrates detailPage filters to have structure `detailPage|<collection id>` instead of
 * `detailPage|<collection slug>`. We need to have collection id stored in the filter because from
 *  now on, collection slugs can be renamed.
 */

import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import _ from 'lodash';
import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {
      jsonNode: {data: nodeData = {}, _id},
    },
    extraContext: {collections},
  } = context;

  const hasDataWHrefBinding = DomTypeUtils.isDynBound(nodeData, 'dataWHref');
  const lastBindingPathFragment: any =
    hasDataWHrefBinding &&
    Array.isArray(nodeData.dyn.bind.dataWHref) &&
    _.last(nodeData.dyn.bind.dataWHref);
  const filter = lastBindingPathFragment && lastBindingPathFragment.filter;
  const filterParts = filter && filter.split('|');
  const filterName = filterParts && filterParts[0];
  const filterArg = filterParts && filterParts[1];
  const collection =
    filterArg && collections && _.find(collections, {slug: filterArg});

  return {
    // If the collection is found by slug, it means the filterArg is a collection slug
    // and therefore, the link has a legacy detailPage filter.
    needed: filterName === 'detailPage' && collection,
    logData: {
      msg: 'dataWHref-bound link has a legacy detailPage filter',
      meta: {
        nodeId: _id,
      },
    },
    apply: () => {
      // These are already checked in `needed` above but we need these for Flow type check to pass.
      if (collection && lastBindingPathFragment) {
        const newFilter = `detailPage|${collection._id}`;
        lastBindingPathFragment.filter = newFilter;
      }
    },
  };
};
